/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MetaformFieldSourceType {
    Default = 'default',
    AccessToken = 'accessToken',
    Autocomplete = 'autocomplete'
}

export function MetaformFieldSourceTypeFromJSON(json: any): MetaformFieldSourceType {
    return MetaformFieldSourceTypeFromJSONTyped(json, false);
}

export function MetaformFieldSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaformFieldSourceType {
    return json as MetaformFieldSourceType;
}

export function MetaformFieldSourceTypeToJSON(value?: MetaformFieldSourceType | null): any {
    return value as any;
}

